// extracted by mini-css-extract-plugin
module.exports = {"offices-list":"OfficesList_offices-list__WIkIG","offices-list__title":"OfficesList_offices-list__title__28BSm"};